import * as environment from '../../../config/environment';

import { BaseAPI } from "../../BaseAPI";

class IstekSikayetAPI extends BaseAPI {
  

  constructor () {
    const baseUrl = environment.API_URL + "IstekSikayetListe";
    super(baseUrl);
  }


  getIstekSikayetListe( tcKimlikNo: string, BasvuruNo?: number){
    var request= new IstekSikayetRequest( tcKimlikNo, BasvuruNo);
    return this.post("",request, false);
  }

}
export default new IstekSikayetAPI();
class IstekSikayetRequest {
  public tcKimlikNo: string;
  public BasvuruNo?: number; 

  constructor( tcKimlikNo: string, BasvuruNo?: number) {
   
    this.tcKimlikNo = tcKimlikNo;
    this.BasvuruNo = BasvuruNo;
  }
}
export { IstekSikayetRequest };